import { getColumnsByNames } from './all-top10-columns-config';

export const topBlockedAppsReportConfig = getColumnsByNames([
    { name: 'application', header: 'App' },
    { name: 'count', width: '40%' },
    { name: 'percentOfTotal', header: '% Blocked Apps', width: '120px'}
]);